<template>
  <div class="caption-s">
    <div
      v-if="flagsLength > 0"
      :id="`grade-popover-${item.id}`"
      class="link"
      :class="colorClass"
      :flags-length="flagsLength"
      tabindex="0"
      @click.stop
    >
      <eg-b-icon icon="flag" />
      {{ flagsLength }}
    </div>

    <eg-b-popover
      v-if="flagsLength > 0"
      :show.sync="show"
      :target="`grade-popover-${item.id}`"
      placement="top"
      triggers="focus"
    >
      <template #title>
        <div class="popover-header-content">
          <div v-if="flagsLength > 1" class="popover-title" :class="colorClass">
            {{ $t("essays.flagsDetected", { count: flagsLength }) }}
          </div>
          <div v-else class="popover-title" :class="colorClass">
            {{ singleFlagTitle }}
          </div>
          <eg-b-button
            :aria-label="$t('common.close')"
            variant="link"
            class="ml-auto text-dark"
            size="sm"
            @click="show = false"
          >
            <eg-b-icon icon="x" scale="1"></eg-b-icon>
          </eg-b-button>
        </div>
      </template>
      <div class="flags">
        <div v-if="flags.includes('closeToGrade')" class="flag mb-1">
          {{ $t("essays.essayGradeCloseToPassingGrade") }}
        </div>
        <div v-if="flags.includes('usedAI')" class="flag mb-1">
          {{ $t("essays.aiDetectedInEssay") }}
        </div>
        <div v-if="flags.includes('plagiarism')" class="flag mb-1">
          {{ $t("essays.plagiarismDetected") }}
        </div>
        <div v-if="flags.includes('templateChecking')" class="flag mb-1">
          {{ $t("essays.wrongTemplate") }}
        </div>
      </div>
      <eg-b-button
        v-if="flags.includes('usedAI') || flags.includes('plagiarism')"
        class="mt-2 text-info px-0"
        variant="link"
        @click="onClickPopoverButton"
      >
        {{ $t("essays.detectionDetails") }}
      </eg-b-button>
    </eg-b-popover>
  </div>
</template>

<script>
import formatDate from "@/utils/formatDate";

export default {
  props: {
    item: {
      type: Object,
      required: true,
    },
    isGrading: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      show: false,
    };
  },

  computed: {
    flags() {
      return (this.item.flags || []).map((flag) => flag.type);
    },

    flagsLength() {
      return this.flags.length;
    },

    singleFlagTitle() {
      if (this.flags.includes("plagiarism")) {
        return this.$t("essays.plagiarismDetected");
      }
      if (this.flags.includes("closeToGrade")) {
        return this.$t("essays.filters.closeToPassingGrade");
      }
      if (this.flags.includes("templateChecking")) {
        return this.$t("essays.filters.templateChecking");
      }
      return this.$t("essays.aiUseDetected");
    },

    colorClass() {
      switch (this.flagsLength) {
        case 0:
          return "";

        case 1:
          return "yellow";

        case 2:
          return "orange";

        default:
          return "danger";
      }
    },
  },

  methods: {
    formatDate,

    async onClickPopoverButton() {
      this.$router.push({
        name: "workspace-essay-view",
        params: {
          workspaceKey: this.$route.params.workspaceKey,
          id: this.$route.params.id,
          essayId: this.item.id,
        },
        query: {
          tab:
            this.flagsLength === 1 && this.flags?.includes("plagiarism")
              ? 3
              : 2,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.link {
  background-color: var(--colors-orange-100);
  padding: 4px 8px;
  border-radius: var(--radius-rd-500);
  height: 24px;
  width: 42px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
}
.yellow {
  color: var(--Text---Low, hsl(45, 74%, 36%));
}

.orange {
  color: hsla(30, 70%, 41%, 1);
}

.danger {
  color: hsla(354, 63%, 47%, 1);
}

.popover-title {
  padding: 0.5rem 0;
}
.popover-header-content {
  display: flex;
  flex-direction: row;
  width: 100%;
}
::v-deep {
  .popover-header {
    padding: 0;
    background-color: transparent;
    border-bottom: unset;
    display: flex;
  }
}
</style>
